<form [formGroup]="form">
  <label for="groupName" class="dx-popup-custom-title">New group</label>
  <input
    id="groupName"
    formControlName="groupName"
    type="text"
    placeholder="Enter a group name..."
    class="textfield"
  />
  <iv-live-input-tooltip #inputTooltip position="right"></iv-live-input-tooltip>
  <div class="buttons-container">
    <button
      (click)="applyGroupName()"
      [disabled]="form.invalid || loading"
      statistic
      statisticElementName="Click save while creating a new group in {{serviceName}}"
      class="iv-flat-button button apply"
    >
      Save
    </button>
    <button
      (click)="close()"
      [disabled]="loading"
      statistic
      statisticElementName="Click cancel while creating a new group in {{serviceName}}"
      class="iv-flat-button iv-flat-button-alert button cancel"
    >
      Cancel
    </button>
  </div>
</form>
